<template>
  <div>
    <b-modal
      id="blockingModal"
      ref="refBlockingModal"
      cancel-variant=""
      ok-title="ok-title"
      cancel-title="cancel-title"
      centered
      hide-footer
      hide-header-close
      title="Модальное окно блокировки"
    >
      <template #modal-header>
        <span>Внимание! Выход из системы произойдет через {{ timeIntervalString }}.</span>
      </template>
      <div class="modal-order-refund-list__btns">
        <b-button
          variant="primary"
          type="submit"
          @click="onSubmit"
        >
          Выйти из системы
        </b-button>
        <b-button
          variant="danger"
          type="submit"
          @click="hideModal"
        >
          Остаться в системе
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
} from 'bootstrap-vue'
import { inject } from '@vue/composition-api'

export default {
  name: 'PrepareBlockingModal',
  components: {
    BButton,
    BModal,
  },
  setup() {
    const {
      variables: {
        refBlockingModal,
        timeIntervalString,
      },
      functions: {
        hideModal,
        showModal,
        onSubmit,
      },
    } = inject('blockingAnAccessSession')

    const provideVariables = {
      refBlockingModal,
      timeIntervalString,
    }

    const provideFunctions = {
      hideModal,
      showModal,
      onSubmit,
    }

    return {
      // Свойства
      ...provideVariables,
      // Методы
      ...provideFunctions,
    }
  },
}
</script>
